<div class="overlay" [ngClass]="{ absolute: absolute }">
  <div class="track-mode">
    <div class="spinners">
      <mat-spinner
        id="track-spinner"
        mode="determinate"
        value="100"
        [strokeWidth]="strokeWidth"
        [diameter]="diameter"
      ></mat-spinner>
      <mat-spinner
        id="value-spinner"
        [diameter]="diameter"
        [strokeWidth]="strokeWidth"
      >
      </mat-spinner>
    </div>
    <span class="spinner-text" *ngIf="spinnerText">{{ spinnerText }}</span>
  </div>
</div>
